import Confetti from 'canvas-confetti'
import "./modules/CookieConsent";

window.addEventListener('start-confetti', () => {
    Confetti();
})

window.addEventListener('meldungen.load-more', event => {
    if (typeof adsbygoogle != 'undefined') {
        setTimeout(() => {
            (adsbygoogle = window.adsbygoogle || []).push({})
        }, 500)
    } else {
        console.info('adsbygoogle nicht initiiert')
    }
})
